import { render, staticRenderFns } from "./ReportingContent.vue?vue&type=template&id=f0a2a53c&scoped=true"
import script from "./ReportingContent.vue?vue&type=script&lang=js"
export * from "./ReportingContent.vue?vue&type=script&lang=js"
import style0 from "./ReportingContent.vue?vue&type=style&index=0&id=f0a2a53c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a2a53c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0a2a53c')) {
      api.createRecord('f0a2a53c', component.options)
    } else {
      api.reload('f0a2a53c', component.options)
    }
    module.hot.accept("./ReportingContent.vue?vue&type=template&id=f0a2a53c&scoped=true", function () {
      api.rerender('f0a2a53c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting-web/ReportingContent.vue"
export default component.exports